<template>
  <div>
    <v-card-text>
      <image-uploader
          :debug="0"
          :maxWidth="512"
          :quality="0.5"
          :autoRotate=false
          outputFormat="blob"
          :preview=false
          :className="['fileinput', { 'fileinput--loaded' : hasImage }]"
          :capture="false"
          accept="video/*,image/*"
          doNotResize="['gif', 'svg']"
          @input="setImage"
      ></image-uploader>
      <div v-if="progress">
        <div v-if="uploadStatus !== ''">{{uploadStatus}} {{progress}} %</div>
      </div>
    </v-card-text>
    <v-card-actions v-if="image">
      <v-spacer></v-spacer>
      <v-btn @click="removeImage" text outlined><v-icon>clear</v-icon></v-btn>
    </v-card-actions>
    <!--        <v-btn-->
    <!--                @click="onPickFile()"-->
    <!--                text outlined>-->
    <!--            <v-icon>add</v-icon>-->
    <!--            <v-icon>photo</v-icon>-->
    <!--        </v-btn>-->
    <!--        <input-->
    <!--                type="file"-->
    <!--                style="display:none"-->
    <!--                ref="fileInput"-->
    <!--                accept="image/*"-->
    <!--                @change="onFilePicked"-->
    <!--        >-->
  </div>
</template>
<script>
import { v1 as uuidv1 } from 'uuid';
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
export default {
  props: ['id'],
  data () {
    return {
      imageUrl: '',
      image: null,
      progress: undefined,
      uploadStatus: ''
    }
  },
  computed: {
    user() {
      return this.$store.getters.user
    }
  },
  methods: {
    hasImage (data) {
        console.log(data)
    },
    // startImageResize (data) {
    //     console.log(data)
    // },
    setImage (img) {
      this.image = img
      this.uploadImage()
    },
    removeImage () {
      this.uploadStatus = ''
      return this.$emit('removeImage', true)
    },
    // endImageResize (endImageResize) {
    //     console.log(endImageResize)
    // },
    // onPickFile () {
    //   this.$refs.fileInput.click()
    // },
    // onFilePicked (event) {
    //   const files = event.target.files
    //   let filename = files[0].name
    //   if (filename.lastIndexOf('.') <= 0) {
    //     return alert('Please add a valid image!')
    //   }
    //   const fileReader = new FileReader()
    //   fileReader.addEventListener('load', () => {
    //     this.imageUrl = fileReader.result
    //   })
    //   fileReader.readAsDataURL(files[0])
    //   this.image = files[0]
    //   this.uploadImage()
    // },
    uploadImage () {
      let file = this.image
      let imageId = uuidv1()
      let userId = this.user.uid
      let storage = this.$store.state.storage
      let imgRef = ref(storage,'/users/' + userId + /smsContent/ + imageId)
      const uploadTask = uploadBytesResumable(imgRef, file)
      return uploadTask.on('state_changed',
          (snapshot) => {
            // Observe state change events such as progress, pause, and resume
            // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
            const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            this.progress = progress
            console.log('Upload is ' + progress + '% done');
            switch (snapshot.state) {
              case 'paused':
                this.uploadStatus = "Uploading paused"
                // console.log('Upload is paused');
                break;
              case 'running':
                this.uploadStatus = "Image Uploading"
                // console.log('Upload is running');
                break;
            }
          },
          (err) => {
            this.$store.dispatch('setError', err)
          },
          () => {
            getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
              //console.log('File available at', downloadURL);
              return this.$emit('imageLinkFound', downloadURL)
            });
          }
      );
    },

  }
}
</script>
